// extracted by mini-css-extract-plugin
module.exports = {"new":"TimesheetItem_new__38qoO","open":"TimesheetItem_open__3EPYf"};